import { getPinList, addPin, cancelPin } from '@/api/pin';

export default {
  namespaced: true,
  state: {
    pinList: []
  },
  mutations: {
    SET_PIN_LIST(state, data) {
      state.pinList = data;
    },
    ADD_PIN(state, data) {
      if (state.pinList.some(item => item.linkId === data.linkId)){
        return;
      }
      state.pinList.unshift(data);
    },
    CANCEL_PIN(state, id) {
      const index = state.pinList.findIndex(item => item.linkId === id);
      state.pinList.splice(index, 1);
    }
  },
  actions: {
    async getPinList(
      { commit },
      params = { pageNum: 1, pageNumber: 1, pageSize: 99 }
    ) {
      const data = await getPinList(params);
      const list = data?.list || [];
      commit('SET_PIN_LIST', list);
    },
    async setPInList({ commit }, data) {
      commit('SET_PIN_LIST', data || []);
    },
    async addPin({ commit }, { id, delay = 0 }) {
      const pinData = await addPin({ linkId: id });
      const timer = setTimeout(() => {
        commit('ADD_PIN', pinData);
        clearTimeout(timer);
      }, delay);
    },
    async cancelPin({ commit }, { id }) {
      await cancelPin({ linkId: id });
      commit('CANCEL_PIN', id);
    },
    addPinData({ commit }, pinData) {
      commit('ADD_PIN', pinData);
    },
    remvoePinData({ commit }, id) {
      commit('ADD_PIN', id);
    }
  },
  getters: {}
};
